import(/* webpackMode: "eager", webpackExports: ["DocsFrame"] */ "/codebuild/output/src3540671299/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/docs/DocsFrame.tsx");
